// Mock survey payload, used when ?mock=1 is present in the URL.
// Matches the shape returned by POST /research/init.
export const mockSurveyData = {
	user_id: 999,
	survey_id: 1,
	require_compliance: 0,
	survey_title: "Mock Survey",
	survey_sub_title: "Local debug mode — no token required",
	survey_intro_text_html:
		"<p>This is mock data used to debug the survey UI. Add <code>?mock=1</code> to the URL to enable.</p>",
	compliance_text: "I agree to participate in this mock survey.",
	questions: [
		{
			id: 1,
			position: 1,
			question_type: "radioboxes",
			question:
				"Considering all the things you do, how would you describe your overall quality of life? Quality of life means more than just health or wealth. It includes the time spent being high/drunk, being sick, in trouble, and in other drug-using activities, etc.",
			is_optional: 0,
			answers: [
				{ id: 101, position: 1, label: "1 - Not at all well" },
				{ id: 102, position: 2, label: "2" },
				{ id: 103, position: 3, label: "3" },
				{ id: 104, position: 4, label: "4" },
				{ id: 105, position: 5, label: "5 - Fair" },
				{ id: 106, position: 6, label: "6" },
				{ id: 107, position: 7, label: "7" },
				{ id: 108, position: 8, label: "8" },
				{ id: 109, position: 9, label: "9" },
				{ id: 110, position: 10, label: "10 - Excellent" },
			],
		},
		{
			id: 2,
			position: 2,
			question_type: "checkboxes",
			question: "Which of the following supports have you used in the last 30 days? (Select all that apply)",
			is_optional: 0,
			answers: [
				{ id: 201, position: 1, label: "Peer support group", is_exclusive: 0 },
				{ id: 202, position: 2, label: "Individual counseling", is_exclusive: 0 },
				{ id: 203, position: 3, label: "Medication-assisted treatment", is_exclusive: 0 },
				{ id: 204, position: 4, label: "Inpatient treatment", is_exclusive: 0 },
				{ id: 205, position: 5, label: "Online community", is_exclusive: 0 },
				{ id: 206, position: 6, label: "None of the above", is_exclusive: 1 },
			],
		},
		{
			id: 3,
			position: 3,
			question_type: "dropdown1",
			question: "How long have you been in recovery?",
			is_optional: 1,
			answers: [
				{ id: 301, position: 1, label: "Less than 30 days" },
				{ id: 302, position: 2, label: "30 days to 6 months" },
				{ id: 303, position: 3, label: "6 months to 1 year" },
				{ id: 304, position: 4, label: "1 to 5 years" },
				{ id: 305, position: 5, label: "More than 5 years" },
			],
		},
		{
			id: 4,
			position: 4,
			question_type: "singletext",
			question: "What is one word that describes your recovery this week?",
			is_optional: 1,
			answers: [],
		},
		{
			id: 5,
			position: 5,
			question_type: "fulltext",
			question: "Is there anything else you'd like to share about your recovery journey?",
			is_optional: 1,
			answers: [],
		},
		{
			id: 6,
			position: 6,
			question_type: "numeric",
			question: "On a scale of 0 to 10, how confident are you in your recovery today?",
			is_optional: 0,
			min_numeric_value: 0,
			max_numeric_value: 10,
			answers: [],
		},
		{
			id: 7,
			position: 7,
			question_type: "info",
			question: "Section 2: Wellbeing",
			description: "The next few questions ask about your wellbeing over the past 30 days.",
			answers: [],
		},
	],
};

export function isMockMode() {
	if (!import.meta.env.DEV) return false;
	const hash = new URLSearchParams(window.location.hash.slice(1));
	const search = new URLSearchParams(window.location.search);
	return hash.get("mock") === "1" || search.get("mock") === "1";
}
